import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';

const initialState = {
    leftsidebarshow: false,
    plukteikenchangeshow: false,
    layerpopovershow: false,
    layerpopovertarget: null,
    plaasgrens: true,
    plaasfill: true,
    plaasnaam: false,
    blokgrens: true,
    blokfill: true,
    bloknaam: false,
    editmode: false,
    reset: false,
    eersteplukdatumchangeshow: false
};

const toggleLeftSidebar = (state, action) => {
    return updateObject(state, { leftsidebarshow: action.value != null ? action.value : !state.leftsidebarshow });
};

const togglePlukteiken = (state, action) => {
    return updateObject(state, { plukteikenchangeshow: !state.plukteikenchangeshow });
};

const toggleEerstePlukdatum = (state, action) => {
    return updateObject(state, { eersteplukdatumchangeshow: !state.eersteplukdatumchangeshow });
};

const toggleLayerPopover = (state, action) => {
    let newvalue = !state.layerpopovershow;
    return updateObject(state, {
        layerpopovershow: action.value != null ? action.value : newvalue,
        layerpopovertarget: action.value != null ? (action.value ? action.target : null) : (newvalue ? action.target : null)
    });
};

const togglePlaasGrens = (state, action) => {
    return updateObject(state, { plaasgrens: !state.plaasgrens });
};

const togglePlaasFill = (state, action) => {
    return updateObject(state, { plaasfill: !state.plaasfill });
};

const togglePlaasNaam = (state, action) => {
    return updateObject(state, { plaasnaam: !state.plaasnaam });
};

const toggleBlokGrens = (state, action) => {
    return updateObject(state, { blokgrens: !state.blokgrens });
};

const toggleBlokFill = (state, action) => {
    return updateObject(state, { blokfill: !state.blokfill });
};

const toggleBlokNaam = (state, action) => {
    return updateObject(state, { bloknaam: !state.bloknaam });
};

const toggleEditmode = (state, action) => {
    return updateObject(state, { editmode: !state.editmode });
};

const resetApp = (state, action) => {
    return updateObject(initialState, { reset: !state.reset });
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.RESET_APP:
            return resetApp(state, action);
        case actionTypes.LEFTSIDEBAR_TOGGLE:
            return toggleLeftSidebar(state, action);
        case actionTypes.PLUKTEIKENCHANGE_TOGGLE:
            return togglePlukteiken(state, action);
        case actionTypes.EERSTEPLUKDATUMCHANGE_TOGGLE:
            return toggleEerstePlukdatum(state, action);
        case actionTypes.LAYERPOPOVER_TOGGLE:
            return toggleLayerPopover(state, action);
        case actionTypes.PLAASGRENS_TOGGLE:
            return togglePlaasGrens(state, action);
        case actionTypes.PLAASFILL_TOGGLE:
            return togglePlaasFill(state, action);
        case actionTypes.PLAASNAAM_TOGGLE:
            return togglePlaasNaam(state, action);
        case actionTypes.BLOKGRENS_TOGGLE:
            return toggleBlokGrens(state, action);
        case actionTypes.BLOKFILL_TOGGLE:
            return toggleBlokFill(state, action);
        case actionTypes.BLOKNAAM_TOGGLE:
            return toggleBlokNaam(state, action);
        case actionTypes.EDITMODE_TOGGLE:
            return toggleEditmode(state, action);
        default:
            return state;
    }
};

export default reducer;